import { useTranslation } from 'react-i18next';

import ViewTab from '../../components/WhereToBuy/ViewTab';
import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: React.Dispatch<React.SetStateAction<SelectedView>>;
};

export default function ViewToggle({ selectedView, setSelectedView }: Props) {
  const { t } = useTranslation('pdp');
  const { RAFFLES, RETAILERS } = SelectedView;

  return (
    <div className="flex w-full gap-2">
      <ViewTab
        isSelected={selectedView === RETAILERS}
        onClick={() => setSelectedView(RETAILERS)}
        name="WTB_VIEW_TOGGLE_RETAILERS"
      >
        {t('retailers')}
      </ViewTab>
      <ViewTab
        isSelected={selectedView === RAFFLES}
        onClick={() => setSelectedView(RAFFLES)}
        name="WTB_VIEW_TOGGLE_RAFFLES"
      >
        {t('raffles')}
      </ViewTab>
    </div>
  );
}
